
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { SlaRule } from 'src/models/sla-rule';
import { map } from 'rxjs/operators';

export type SlaRulePayload = {
  serviceType: string;
  priority: string;
  responseTimeValue: number;
  responseTimeUnit: string;
  resolutionTimeValue: number;
  resolutionTimeUnit: string;
};

@Injectable({
  providedIn: 'root',
})
export class SlaRuleService {
  private _endpoint = environment.endpoint();

  private _workspace = '/sla-rules/workspace';
  private _workspaceId = '/sla-rules/workspace/:id';

  private _contractRules = '/contracts/:contractId/sla-rules';
  private _contractRulesId = '/contracts/:contractId/sla-rules/:id';

  constructor(private http: HttpClient) {}

  listWorkspaceDefaults(): Observable<SlaRule[]> {
    const url = this._endpoint + this._workspace;
    return this.http.get<any[]>(url).pipe(map((arr) => (arr || []).map((x) => new SlaRule(x))));
  }

  createWorkspaceDefault(body: SlaRulePayload): Observable<SlaRule> {
    const url = this._endpoint + this._workspace;
    return this.http.post<any>(url, body).pipe(map((x) => new SlaRule(x)));
  }

  updateWorkspaceDefault(id: string, body: Partial<SlaRulePayload>): Observable<SlaRule> {
    const url = this._endpoint + this._workspaceId.replace(':id', id);
    return this.http.patch<any>(url, body).pipe(map((x) => new SlaRule(x)));
  }

  deleteWorkspaceDefault(id: string): Observable<SlaRule> {
    const url = this._endpoint + this._workspaceId.replace(':id', id);
    return this.http.delete<any>(url).pipe(map((x) => new SlaRule(x)));
  }

  listContractRules(contractId: string): Observable<SlaRule[]> {
    const url = this._endpoint + this._contractRules.replace(':contractId', contractId);
    return this.http.get<any[]>(url).pipe(map((arr) => (arr || []).map((x) => new SlaRule(x))));
  }

  createContractRule(contractId: string, body: SlaRulePayload): Observable<SlaRule> {
    const url = this._endpoint + this._contractRules.replace(':contractId', contractId);
    return this.http.post<any>(url, body).pipe(map((x) => new SlaRule(x)));
  }

  updateContractRule(contractId: string, id: string, body: Partial<SlaRulePayload>): Observable<SlaRule> {
    const url =
      this._endpoint +
      this._contractRulesId.replace(':contractId', contractId).replace(':id', id);

    return this.http.patch<any>(url, body).pipe(map((x) => new SlaRule(x)));
  }

  deleteContractRule(contractId: string, id: string): Observable<SlaRule> {
    const url =
      this._endpoint +
      this._contractRulesId.replace(':contractId', contractId).replace(':id', id);

    return this.http.delete<any>(url).pipe(map((x) => new SlaRule(x)));
  }
}
